/* eslint-disable dot-notation */
import { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Switcher.module.scss';

const noOp = () => {};

const Switcher = ({
  renderLeftIcon,
  renderRightIcon,
  dataTest = '',
  onClickLeft = noOp,
  onClickRight = noOp,
  isPositionRight = false,
  colorSchema = 'default',
  className = '',
  height = 44
}) => {
  const [isRightActive, setIsRightActive] = useState(false);

  const toggleIsRight = () => {
    setIsRightActive(!isRightActive);
    if (isRightActive) {
      onClickLeft();
    } else {
      onClickRight();
    }
  };

  useEffect(() => {
    setIsRightActive(isPositionRight);
  }, [isPositionRight, setIsRightActive]);

  const ballStyles = classNames(styles['switcher__ball'], {
    [styles['switcher__ball--right']]: isRightActive
  });

  const switcherLeftStyles = classNames(styles['switcher__icon'], {
    [styles['switcher__icon--selected']]: !isRightActive
  });

  const switcherRightStyles = classNames(styles['switcher__icon'], {
    [styles['switcher__icon--selected']]: isRightActive
  });

  return (
    <Fragment>
      <style>
        {`[data-test="${dataTest}"] {
          --switcher-height: ${height}px;
        }`}
      </style>
      <div
        className={classNames(styles['switcher'], className, {
          [styles['switcher--color-schema-date-filter']]:
            colorSchema === 'date-filter',
          [styles['switcher--color-schema-white']]: colorSchema === 'white',
          [styles['switcher--color-schema-interaction-transparent']]:
            colorSchema === 'interaction-transparent',
          [styles['switcher--color-schema-white-inverted']]:
            colorSchema === 'white-inverted'
        })}
        onClick={toggleIsRight}
        role="button"
        tabIndex={0}
        data-test={dataTest}
      >
        <span className={ballStyles} />
        <div className={styles['switcher__overlay']}>
          <span className={switcherLeftStyles}>{renderLeftIcon()}</span>
          <span className={switcherRightStyles}>{renderRightIcon()}</span>
        </div>
      </div>
    </Fragment>
  );
};

Switcher.propTypes = {
  renderLeftIcon: PropTypes.func.isRequired,
  renderRightIcon: PropTypes.func.isRequired,
  dataTest: PropTypes.string,
  onClickLeft: PropTypes.func,
  onClickRight: PropTypes.func,
  isPositionRight: PropTypes.bool,
  colorSchema: PropTypes.oneOf([
    'default',
    'date-filter',
    'white',
    'interaction-transparent',
    'white-inverted'
  ]),
  className: PropTypes.string,
  height: PropTypes.number
};

export default Switcher;
